import { Equipment } from '@bechtel/sr-types';
import { isNil, pick } from 'lodash';
import { EquipmentFeedbackFormikState } from './form/types';

export const equipmentFeedbackInitialValues: EquipmentFeedbackFormikState = {
  tag: '',
  constructionStatus: '',
  installedBy: '',
  installedTime: '',
  inspectedBy: '',
  inspectedTime: '',
  id: '',
  tagInvalid: false,
};

export const getFormikData = (data: Equipment, keys: string[]) => {
  if (!data) return;
  const formData = { ...data };
  // Transform null to empty string for all the properties of the object
  for (const key in formData) {
    if (isNil(formData[key])) {
      formData[key] = '';
    }
  }
  // Update matching columns from equimentData to input object
  const formikState: Partial<EquipmentFeedbackFormikState> = pick(formData, keys);

  return formikState;
};
